import "./src/styles/global.css";

const GA_MEASUREMENT_ID = "G-MYFZK1EWH7";

export const onRouteUpdate = ({ location }) => {
    if (typeof window.gtag === "function") {
        window.gtag("config", GA_MEASUREMENT_ID, {
            page_path: location.pathname + location.search + location.hash,
        });
    }

    if (location.action === "PUSH") {
        window.setTimeout(() => window.scrollTo(0, 0), 10);
    }
};